module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flexContainer fd-c as-s ai-s ac-s",
    attrs: {
      "id": "builderWrapper"
    }
  }, [(_vm.loader) ? _c('Spinner') : _vm._e(), _vm._v(" "), (_vm.$route.name === 'Plano' && _vm.hasLoadData) ? _c('header', {
    staticClass: "rel"
  }, [(_vm.hasLoadData && !_vm.isNewPlano) ? _c('HeaderPlano') : _vm._e(), _vm._v(" "), (_vm.hasLoadData && _vm.isNewPlano) ? _c('HeaderPlanoMassMarket') : _vm._e(), _vm._v(" "), (_vm.getShowRestore === false && !_vm.isNewPlano) ? _c('MenuMainPlano') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rel content-builder-main"
  }, [(_vm.hasLoadData) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(!_vm.isNewPlano) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('PlanoEditor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlano),
      expression: "isPlano"
    }]
  }), _vm._v(" "), (_vm.isModuleEditor) ? _c('GroupEditor') : _vm._e()], 1) : _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('PlanoEditorMassMarket', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlano),
      expression: "isPlano"
    }]
  }), _vm._v(" "), (_vm.isModuleEditor) ? _c('ModuleEditor') : (_vm.isShelfEditor) ? _c('ShelfEditor') : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.canDisplayMenuShades) ? _c('MenuShades', {
    key: 'menuShades',
    staticClass: "abs sidebar"
  }) : _vm._e(), _vm._v(" "), (_vm.canDisplayMenuScratch) ? _c('ScratchPad', {
    key: 'menuScratch',
    staticClass: "abs sidebar"
  }) : _vm._e(), _vm._v(" "), (_vm.canDisplayMenuFavorite) ? _c('Favorite', {
    key: 'menuScratch',
    staticClass: "abs sidebar"
  }) : _vm._e(), _vm._v(" "), (_vm.canDisplayMenuLibrary) ? _c('MenuMain', {
    key: 'menuLibrary',
    staticClass: "abs sidebar"
  }) : _vm._e(), _vm._v(" "), (_vm.canDisplayComments) ? _c('Sidebar', {
    key: 'comments'
  }, [_c('Comments')], 1) : _vm._e(), _vm._v(" "), (_vm.canDisplayExports) ? _c('Sidebar', {
    key: 'exports'
  }, [_c('Exports')], 1) : _vm._e(), _vm._v(" "), (_vm.canDisplayMenuTicketStrip) ? _c('TicketStrip', {
    key: 'ticketstrip',
    staticClass: "abs sidebarLeft"
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showModalFavorite === true && _vm.getShowRestore === false) ? _c('ModalFavorite') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b927b5ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/Plano.vue
// module id = 3353
// module chunks = 0